/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  Comment,
  CommentReply,
  List,
  OrganizationMember,
  PostCommentReplySchema,
  PostCommentSchema,
  UpdateCommentSchema,
} from "./data-contracts";

/**
 * No description
 * @tags change-request-comments
 * @name ListCommentsInChangeRequest
 * @summary List all change request comments
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments
 * @secure
 */

// @ts-ignore
export const listCommentsInChangeRequest: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * When provided, only comments with the given status are returned. Defaults to "all".
     * @default "all"
     */
    status?: "all" | "open" | "resolved";
    /** The target page of the comment */
    targetPage?: string;
    /** User IDs to filter queried comments on */
    authors?: string[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Comment[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments",
  method: "get",
  streaming: false,
  tags: ["change-request-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name PostCommentInChangeRequest
 * @summary Create a change request comment
 * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/comments
 * @secure
 */

// @ts-ignore
export const postCommentInChangeRequest: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {};
  RequestBody: PostCommentSchema;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments",
  method: "post",
  streaming: false,
  tags: ["change-request-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name GetCommentInChangeRequest
 * @summary Get a change request comment
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const getCommentInChangeRequest: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the comment */
    commentId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}",
  method: "get",
  streaming: false,
  tags: ["change-request-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name DeleteCommentInChangeRequest
 * @summary Delete a change request comment
 * @request DELETE:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const deleteCommentInChangeRequest: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the comment */
    commentId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}",
  method: "delete",
  streaming: false,
  tags: ["change-request-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name UpdateCommentInChangeRequest
 * @summary Update a change request comment
 * @request PUT:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}
 * @secure
 */

// @ts-ignore
export const updateCommentInChangeRequest: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the comment */
    commentId: string;
  };
  RequestQuery: {};
  RequestBody: UpdateCommentSchema;
  RequestHeaders: {};
  ResponseBody: Comment;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}",
  method: "put",
  streaming: false,
  tags: ["change-request-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name ListCommentRepliesInChangeRequest
 * @summary List all change request comment replies
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies
 * @secure
 */

// @ts-ignore
export const listCommentRepliesInChangeRequest: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the comment */
    commentId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: CommentReply[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies",
  method: "get",
  streaming: false,
  tags: ["change-request-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name PostCommentReplyInChangeRequest
 * @summary Create a change request comment reply
 * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies
 * @secure
 */

// @ts-ignore
export const postCommentReplyInChangeRequest: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the comment */
    commentId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: PostCommentReplySchema;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies",
  method: "post",
  streaming: false,
  tags: ["change-request-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name GetCommentReplyInChangeRequest
 * @summary Get a change request comment reply
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const getCommentReplyInChangeRequest: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the comment */
    commentId: string;
    /** The unique id of the comment reply */
    commentReplyId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}",
  method: "get",
  streaming: false,
  tags: ["change-request-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name UpdateCommentReplyInChangeRequest
 * @summary Update a change request comment reply
 * @request PUT:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const updateCommentReplyInChangeRequest: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the comment */
    commentId: string;
    /** The unique id of the comment reply */
    commentReplyId: string;
  };
  RequestQuery: {};
  RequestBody: UpdateCommentSchema;
  RequestHeaders: {};
  ResponseBody: CommentReply;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}",
  method: "put",
  streaming: false,
  tags: ["change-request-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments
 * @name DeleteCommentReplyInChangeRequest
 * @summary Delete a change request comment reply
 * @request DELETE:/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}
 * @secure
 */

// @ts-ignore
export const deleteCommentReplyInChangeRequest: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
    /** The unique id of the comment */
    commentId: string;
    /** The unique id of the comment reply */
    commentReplyId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/comments/{commentId}/replies/{commentReplyId}",
  method: "delete",
  streaming: false,
  tags: ["change-request-comments"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags change-request-comments, critical
 * @name ListCommentersInChangeRequest
 * @summary List all users who commented in a CR
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/commenters
 * @secure
 */

// @ts-ignore
export const listCommentersInChangeRequest: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OrganizationMember[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/commenters",
  method: "get",
  streaming: false,
  tags: ["change-request-comments", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};
